import { useEffect, useState } from "react";
import image from "../error.png";
import { useAuthState } from "../context/AuthContext";


const ErrorPage = ({ error }) => {

    const { user } = useAuthState();
    const [displayError, setDisplayError] = useState("");
    const dashLink = user && user !== null && user.x_is_housemanagement === true? "/hw/dashboard/":"/dashboard/";

    useEffect(() => {
        if (typeof error === "object") {
            if (error.response.data.detail !== undefined) setDisplayError(error.response.data.detail);
            else setDisplayError("Da ist etwas schief gelaufen. Bitte versuchen Sie es später nochmal.");
        }
        else if (typeof error === "string" && error !== "") setDisplayError(error);
        else setDisplayError("Da ist etwas schief gelaufen. Bitte versuchen Sie es später nochmal.")
    }, [error])

    return (
        <div className="splash">
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%"}}>
                <img style={{userSelect: "none"}} className="img-fluid" src={image} alt="logo" width={500} />
                <h1 style={{marginTop: 10, fontSize: 40, fontWeight: 900}} className="text-light">Fehler aufgetreten</h1>
                <p style={{marginTop: 10, marginBottom: 60, userSelect: "none"}}>{displayError}</p>
                <a
                    href={dashLink}
                    className="btn btn-warning"
                >Zurück</a>
            </div>
        </div>
    )
}

export default ErrorPage;